

import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { MessageSquare, X, Play, ArrowRight } from "lucide-react";
import "./theme.css";

// Import thumbnails and videos
import vid1 from '../../Assesst/vide1.mp4';
import thm1 from '../../Assesst/thmVernonNJ.png';
import vid2 from '../../Assesst/vid2.mp4';
import thm2 from '../../Assesst/thmparsipany.png';
import vid3 from '../../Assesst/vid3.mp4';
import thm3 from '../../Assesst/Image-121.jpg';
import vid4 from '../../Assesst/vid4.mp4';
import thm4 from '../../Assesst/Image-912.jpg';
import vid5 from '../../Assesst/vid5.mp4';
import thm5 from '../../Assesst/thmrefacing.png';
import vid6 from '../../Assesst/vid6.mp4';
import thm6 from '../../Assesst/629992239_17898564786381730_7476464499665088684_n.jpg';
import thm7 from "../../Assesst/vid1.mp4";    
import thm8 from "../../Assesst/thms8.png";
import vid8 from "../../Assesst/laminancekitchen.mp4";
import thm9 from "../../Assesst/newkit.jpeg";
import vid9 from "../../Assesst/laminancekitchenrockwayNj.mp4";
import thm10 from "../../Assesst/rockwaythm.jpeg";

const CollectionsPage = () => {
  const navigate = useNavigate();
  const { videoId } = useParams();
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState("");
  const [selectedVideoThumbnail, setSelectedVideoThumbnail] = useState("");
  const videoRef = useRef(null);

  const collections = [
    {
      id: "laminance-cabinetry-Rockway-NewJersey",
      video: vid9,
      thumbnail: thm10,
      title: "Modern Acrylic Kitchen Collection - Laminance Cabinetry",
      description: "Luxury acrylic kitchen cabinets with high-gloss finish, scratch-resistant surface, and modern European design. Transform your kitchen with premium acrylic cabinets by Laminance Cabinetry.",
      shortDescription: "Premium high-gloss acrylic kitchen cabinets with modern European design",
      keywords: "modern acrylic kitchen, high-gloss cabinets, luxury kitchen, European kitchen design, Laminance Cabinetry",
      category: "Acrylic",
      longDescription: "Experience the elegance of our Modern Acrylic Kitchen Collection. These premium cabinets feature a stunning high-gloss finish that reflects light beautifully, creating an airy and sophisticated atmosphere. The scratch-resistant surface ensures lasting beauty, while the soft-close mechanisms provide quiet, smooth operation. Available in over 50 stunning colors."
    },
    {
      id: "laminance-cabinetry-Vernon-NewJersey",
      video: vid8,
      thumbnail: thm9,
      title: "Modern Acrylic Kitchen Collection - Laminance Cabinetry",
      description: "Luxury acrylic kitchen cabinets with high-gloss finish, scratch-resistant surface, and modern European design. Transform your kitchen with premium acrylic cabinets by Laminance Cabinetry.",
      shortDescription: "Premium high-gloss acrylic kitchen cabinets with modern European design",
      keywords: "modern acrylic kitchen, high-gloss cabinets, luxury kitchen, European kitchen design, Laminance Cabinetry",
      category: "Acrylic",
      longDescription: "Experience the elegance of our Modern Acrylic Kitchen Collection. These premium cabinets feature a stunning high-gloss finish that reflects light beautifully, creating an airy and sophisticated atmosphere. The scratch-resistant surface ensures lasting beauty, while the soft-close mechanisms provide quiet, smooth operation. Available in over 50 stunning colors."
    },
    // {
    //   id: "laminance-cabinetry-Signature-Luxury-Kitchen-Collection",
    //   video: thm7,
    //   thumbnail: thm8,
    //   title: "Signature Luxury Kitchen Collection - Laminance Cabinetry",
    //   description: "Premium signature kitchen collection with custom finishes, elegant hardware, and timeless design. Exclusive designs crafted for discerning homeowners.",
    //   shortDescription: "Premium signature kitchen collection with custom finishes",
    //   keywords: "signature kitchen, luxury cabinets, custom kitchen, premium finishes, Laminance Cabinetry",
    //   category: "Signature",
    //   longDescription: "Our Signature Luxury Collection represents the pinnacle of kitchen design. Each cabinet is custom-crafted with premium materials, featuring elegant hardware and timeless design elements that will never go out of style."
    // },
    {
      id: "laminance-cabinetry-LongValley-NewJersey",
      video: vid1,
      thumbnail: thm1,
      title: "Matte Finish Kitchen Collection - Laminance Cabinetry",
      description: "Sophisticated matte finish cabinets with anti-fingerprint technology and soft-touch surfaces. Modern elegance for contemporary kitchens.",
      shortDescription: "Sophisticated matte finish cabinets with anti-fingerprint technology",
      keywords: "matte kitchen cabinets, soft-touch finish, anti-fingerprint, modern matte kitchen, Laminance Cabinetry",
      category: "Matte",
      longDescription: "Discover the sophisticated beauty of our Matte Finish Collection. These cabinets feature a luxurious soft-touch surface with advanced anti-fingerprint technology, keeping your kitchen looking pristine with minimal maintenance."
    },
    {
      id: "laminance-cabinetry-Parsippany-NewJersey",
      video: vid2,
      thumbnail: thm2,
      title: "Glass Front Kitchen Collection - Laminance Cabinetry",
      description: "Elegant glass-front cabinets with interior lighting options, perfect for displaying fine dinnerware. Create a stunning focal point in your kitchen.",
      shortDescription: "Elegant glass-front cabinets with interior lighting options",
      keywords: "glass front cabinets, illuminated cabinets, display cabinets, contemporary kitchen, Laminance Cabinetry",
      category: "Glass",
      longDescription: "Showcase your finest dinnerware with our Glass Front Collection. These elegant cabinets feature tempered glass panels and optional interior LED lighting, creating a stunning display that adds depth and character to your kitchen."
    },
    // {
    //   id: "laminance-cabinetry-LaminanceCabinetryShowroom-NewJersey",
    //   video: vid3,
    //   thumbnail: thm3,
    //   title: "European Style Kitchen Collection - Laminance Cabinetry",
    //   description: "Sleek European-style cabinets with handle-less design, integrated appliances, and minimalist aesthetics. Clean lines for modern living.",
    //   shortDescription: "Sleek European-style cabinets with handle-less design",
    //   keywords: "European kitchen, handle-less cabinets, minimalist design, modern European cabinets, Laminance Cabinetry",
    //   category: "European",
    //   longDescription: "Embrace minimalist elegance with our European Style Collection. Featuring handle-less designs, integrated appliances, and clean lines, these cabinets maximize space and create a seamless, contemporary look."
    // },
    // {
    //   id: "laminance-cabinetry-laminance-devarrd",
    //   video: vid4,
    //   thumbnail: thm4,
    //   title: "Traditional Wood Kitchen Collection - Laminance Cabinetry",
    //   description: "Warm  crafted from premium solid hardwoods with timeless elegance. Classic beauty that never fades.",
    //   shortDescription: "Warm  from premium solid hardwoods",
    //   keywords: "traditional kitchen, wood cabinets, solid wood, classic kitchen design, custom wood cabinets, Laminance Cabinetry",
    //   category: "Wood",
    //   longDescription: "Bring timeless warmth to your home with our Traditional Wood Collection. Crafted from premium solid hardwoods, these cabinets feature intricate details and rich finishes that add character and elegance to any kitchen."
    // },
    {
      id: "laminance-cabinetry-KitchenRefacing-Montville-Warren-Nj",
      video: vid5,
      thumbnail: thm5,
      title: "Modular Kitchen System Collection - Laminance Cabinetry",
      description: "Flexible modular kitchen system with interchangeable modules and smart storage solutions. Design your perfect kitchen layout.",
      shortDescription: "Flexible modular kitchen system with smart storage solutions",
      keywords: "modular kitchen, smart storage, custom modules, premium kitchen system, Laminance Cabinetry",
      category: "Modular",
      longDescription: "Create your dream kitchen layout with our Modular Kitchen System. Featuring interchangeable modules and innovative storage solutions, this collection offers unparalleled flexibility to adapt to your unique needs."
    },
    // {
    //   id: "laminance-cabinetry-Allinclusive-kitchen",
    //   video: vid6,
    //   thumbnail: thm6,
    //   title: "Urban Contemporary Kitchen Collection - Laminance Cabinetry",
    //   description: "Bold contemporary kitchen designs with mixed materials and innovative storage for modern urban living. Make a statement with your kitchen.",
    //   shortDescription: "Bold contemporary kitchen designs for modern urban living",
    //   keywords: "urban kitchen, contemporary design, modern urban, bold kitchen colors, city apartment kitchen, Laminance Cabinetry",
    //   category: "Urban",
    //   longDescription: "Make a bold statement with our Urban Contemporary Collection. Featuring mixed materials, vibrant colors, and innovative storage solutions, these cabinets are designed for the modern urban lifestyle."
    // },
  ];

  const handleBookConsultation = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/contact#contact-form');
  };

  const handleViewAllCollections = () => {
    navigate('/catalog');
  };

  const openVideoModal = (collection) => {
    setSelectedVideo(collection.video);
    setSelectedVideoTitle(collection.title);
    setSelectedVideoThumbnail(collection.thumbnail);
    // Update URL to shareable format
    window.history.pushState({}, '', `/collections/video/${collection.id}`);
  };

  const closeVideoModal = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setSelectedVideo(null);
    setSelectedVideoTitle("");
    setSelectedVideoThumbnail("");
    // Restore original URL
    window.history.pushState({}, '', '/collections');
  };

  // Close modal on ESC key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        closeVideoModal();
      }
    };

    if (selectedVideo) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset';
    };
  }, [selectedVideo]);

  // Handle direct URL access to specific video
  useEffect(() => {
    if (videoId) {
      const collection = collections.find(c => c.id === videoId);
      if (collection) {
        setTimeout(() => {
          openVideoModal(collection);
        }, 500);
      }
    }
  }, [videoId]);

  // Handle browser back button
  useEffect(() => {
    const handlePopState = () => {
      if (selectedVideo) {
        closeVideoModal();
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [selectedVideo]);

  // Generate VideoObject schema for each collection
  const videoSchemas = collections.map((collection) => ({
  "@context": "https://schema.org",
  "@type": "VideoObject",

  "name": collection.title,

  "description": collection.description,

  "thumbnailUrl": collection.thumbnail,

  "contentUrl": collection.video,

  "embedUrl": `https://laminance.com/collections/video/${collection.id}`,

  "uploadDate": "2025-01-01T10:00:00-05:00",

  "duration": "PT2M",

  "keywords": Array.isArray(collection.keywords)
    ? collection.keywords.join(", ")
    : collection.keywords,

  "publisher": {
    "@type": "Organization",

    "name": "Laminance Cabinetry",

    "logo": {
      "@type": "ImageObject",
      "url": "https://laminance.com/assets/Images/logo.png"
    }
  },

  "provider": {
    "@type": "Organization",

    "name": "Laminance Cabinetry",

    "sameAs": "https://laminance.com"
  }
}));

  // Main page schema
const pageSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",

  "name": "Premium Kitchen Cabinet Collections | Laminance Cabinetry",

  "description":
    "Explore our exclusive kitchen cabinet collections including modern acrylic cabinets, luxury matte kitchens, European style, traditional wood, and modular kitchen systems. Premium quality cabinets in New Jersey.",

  "url": "https://laminance.com/collections",

  "mainEntity": {
    "@type": "ItemList",

    "itemListElement": collections.map((collection, index) => ({
      "@type": "ListItem",

      "position": index + 1,

      "item": {
        "@type": "Product",

        "name": collection.title,

        "description": collection.description,

        "image": collection.thumbnail,

        "category": collection.category,

        "sku": collection.id?.toString(),

        "brand": {
          "@type": "Brand",
          "name": "Laminance Cabinetry"
        },

        "offers": {
          "@type": "Offer",

          "url": `https://laminance.com/collections/${collection.slug}`,

          "availability": "https://schema.org/InStock",

          "priceCurrency": "USD",

          "shippingDetails": {
            "@type": "OfferShippingDetails",

            "shippingDestination": {
              "@type": "DefinedRegion",
              "addressCountry": "US"
            },

            "deliveryTime": {
              "@type": "ShippingDeliveryTime",

              "handlingTime": {
                "@type": "QuantitativeValue",
                "minValue": 2,
                "maxValue": 5,
                "unitCode": "DAY"
              },

              "transitTime": {
                "@type": "QuantitativeValue",
                "minValue": 7,
                "maxValue": 21,
                "unitCode": "DAY"
              }
            }
          },

          "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",

            "applicableCountry": "US",

            "returnPolicyCategory":
              "https://schema.org/MerchantReturnNotPermitted"
          }
        }
      }
    }))
  }
};

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Laminance Cabinetry",
    "description": "Premier custom kitchen cabinet and complete kitchen renovation services in New Jersey. Specializing in acrylic cabinets, custom cabinetry, and luxury kitchen collections.",
    "url": "https://laminance.com",
    "telephone": "+18624506069",
    "email": "contactus@laminance.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "418 Rt 23",
      "addressLocality": "Franklin",
      "addressRegion": "NJ",
      "postalCode": "07416",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.1220",
      "longitude": "-74.5804"
    },
    "areaServed": {
      "@type": "State",
      "name": "New Jersey"
    },
    "priceRange": "$$",
    "openingHours": "Mo-Fr 09:00-18:00",
    "sameAs": [
      "https://www.facebook.com/laminancecabinetry",
      "https://www.instagram.com/laminancecabinetry"
    ]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://laminance.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Kitchen Collections",
        "item": "https://laminance.com/collections"
      }
    ]
  };

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Premium Kitchen Cabinet Collections | Modern Acrylic & Luxury Kitchens | Laminance Cabinetry</title>
        <meta name="title" content="Premium Kitchen Cabinet Collections | Modern Acrylic & Luxury Kitchens | Laminance Cabinetry" />
        <meta name="description" content="Explore our exclusive kitchen cabinet collections featuring modern acrylic cabinets, luxury matte kitchens, European style cabinetry, traditional wood, and modular kitchen systems. Premium quality custom cabinets in New Jersey. Free consultation!" />
        <meta name="keywords" content="kitchen cabinet collections, modern acrylic cabinets, luxury kitchen cabinets, European kitchens, modular kitchen, custom cabinets New Jersey, Laminance Cabinetry, kitchen renovation NJ" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta name="author" content="Laminance Cabinetry" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://laminance.com/collections" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://laminance.com/collections" />
        <meta property="og:title" content="Premium Kitchen Cabinet Collections | Laminance Cabinetry" />
        <meta property="og:description" content="Explore our exclusive kitchen cabinet collections - modern acrylic, luxury matte, European style, traditional wood, and modular kitchens. Premium quality cabinets in New Jersey." />
        <meta property="og:image" content={thm9} />
        <meta property="og:image:alt" content="Laminance Cabinetry premium kitchen cabinet collections showcase - modern acrylic kitchen" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Laminance Cabinetry" />
        <meta property="og:locale" content="en_US" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://laminance.com/collections" />
        <meta name="twitter:title" content="Premium Kitchen Cabinet Collections | Laminance Cabinetry" />
        <meta name="twitter:description" content="Explore our exclusive kitchen cabinet collections - modern acrylic, luxury matte, and European style kitchens in New Jersey." />
        <meta name="twitter:image" content={thm9} />
        <meta name="twitter:image:alt" content="Laminance Cabinetry kitchen cabinet collections" />
        <meta name="twitter:site" content="@laminance" />
        
        {/* Geo Meta Tags for Local SEO */}
        <meta name="geo.region" content="US-NJ" />
        <meta name="geo.placename" content="Franklin" />
        <meta name="geo.position" content="41.1220;-74.5804" />
        <meta name="ICBM" content="41.1220, -74.5804" />
        
        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(pageSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        {videoSchemas.map((schema, index) => (
          <script key={index} type="application/ld+json">{JSON.stringify(schema)}</script>
        ))}
      </Helmet>

      {/* Fullscreen Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm"
          onClick={closeVideoModal}
          role="dialog"
          aria-modal="true"
          aria-label="Video player modal"
        >
          <button
            onClick={closeVideoModal}
            className="absolute top-6 right-6 z-50 bg-black/50 hover:bg-black text-white p-3 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/50 backdrop-blur-sm"
            aria-label="Close video"
          >
            <X size={32} />
          </button>

          <div className="relative w-full h-full max-w-6xl max-h-[90vh] p-4" onClick={(e) => e.stopPropagation()}>
            
            
            <video
              ref={videoRef}
              src={selectedVideo}
              className="w-full h-full object-contain rounded-lg"
              autoPlay
              controls
              playsInline
              poster={selectedVideoThumbnail}
              
            >
              <source src={selectedVideo} type="video/mp4" />
               Laminance Cabinetry.
            </video>
          </div>
          
          {/* Share URL Indicator */}
          
        </div>
      )}

      <section 
        id="collections-section"
        className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden"
        style={{
          background: "var(--gradient-bg)",
          minHeight: "100vh",
        }}
        aria-labelledby="collections-heading"
      >
        {/* Hidden SEO Image */}
        <img 
          src={thm9}
          alt="Laminance Cabinetry premium kitchen cabinet collections - modern acrylic kitchen showcase in New Jersey"
          className="hidden"
          loading="eager"
          fetchPriority="high"
          width="1920"
          height="1080"
        />

        {/* Background Decorative Elements */}
        <div 
          className="absolute top-0 left-0 w-72 h-72 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-60 blur-3xl" 
          aria-hidden="true"
          style={{ backgroundColor: "var(--color-primary-100)" }}
        ></div>
        <div 
          className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3 opacity-70 blur-3xl" 
          aria-hidden="true"
          style={{ backgroundColor: "var(--color-amber-50)" }}
        ></div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          {/* Section Header */}
          <header className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 mx-auto"
              style={{
                background: "var(--bg-primary-10)",
                border: "1px solid var(--border-primary-20)",
              }}
            >
              <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
              <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                Premium Collections
              </span>
            </div>
            
            <h1
              id="collections-heading"
              className="bell-mt-primary text-4xl sm:text-5xl md:text-6xl font-bold mb-4"
              style={{
                background: "var(--gradient-primary)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Our Exclusive Kitchen Collections
            </h1>
            
            <p 
              className="inter-secondary text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto"
              style={{ color: "var(--color-gray-600)" }}
            >
              Discover premium custom kitchen cabinets, modern acrylic kitchens, luxury matte finishes, 
              European-style cabinetry, and modular kitchen systems by Laminance Cabinetry. Each collection is crafted with 
              precision and designed to transform your kitchen into a masterpiece.
            </p>
            
            <div className="flex justify-center mt-6" aria-hidden="true">
              <div 
                className="w-24 h-1 rounded-full"
                style={{ background: "var(--gradient-primary)" }}
              ></div>
            </div>
          </header>

          {/* Collections Grid - SEO Optimized */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {collections.map((collection, index) => (
              <article
                key={collection.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                onClick={() => openVideoModal(collection)}
                aria-label={`Watch video: ${collection.title}`}
              >
                <div className="relative" style={{ paddingBottom: "75%" }}>
                  <img
                    src={collection.thumbnail}
                    alt={`${collection.title} - premium custom kitchen cabinet collection by Laminance Cabinetry in New Jersey`}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    width="600"
                    height="450"
                    decoding="async"
                  />
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <div className="bg-white/90 rounded-full p-4 transform scale-90 group-hover:scale-100 transition-transform duration-300">
                      <Play className="w-8 h-8" style={{ color: "var(--color-primary-600)", fill: "var(--color-primary-600)" }} />
                    </div>
                  </div>
                  
                  {/* Category Badge */}
                  
                </div>

                
              </article>
            ))}
          </div>

          {/* SEO Content Section */}
          <div className="mt-16 text-center">
            <div className="max-w-4xl mx-auto">
              <h2 className="bell-mt-primary text-2xl md:text-3xl font-bold mb-4" style={{ color: "var(--color-primary-500)" }}>
                Premium Kitchen Cabinet Solutions in New Jersey
              </h2>
              <p className="inter-secondary text-base md:text-lg mb-6" style={{ color: "var(--color-gray-600)" }}>
                At Laminance Cabinetry, we specialize in custom kitchen cabinets, acrylic cabinets, modern kitchen designs, 
                and complete kitchen renovations. Our all-inclusive packages cover everything from design to installation, 
                ensuring a stress-free experience. Serving all of New Jersey with premium quality and professional service.
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Custom Kitchen Cabinets
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Laminance Cabinetry
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Modern Kitchen Design
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  European Cabinetry
                </span>
                <span className="inter-secondary text-sm px-3 py-1 rounded-full" style={{ backgroundColor: "var(--bg-primary-10)", color: "var(--color-primary-600)" }}>
                  Kitchen Renovation NJ
                </span>
              </div>
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-16">
            <div 
              className="rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 text-white max-w-4xl mx-auto shadow-2xl"
              style={{
                background: "var(--gradient-primary)",
                boxShadow: "var(--shadow-large)",
              }}
            >
              <h3 className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
                Need a Custom Kitchen Design?
              </h3>
              <p 
                className="inter-secondary text-base sm:text-lg mb-6"
                style={{ color: "rgba(255, 255, 255, 0.95)" }}
              >
                Our expert designers will create the perfect kitchen for your space. Free in-home consultation available.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={handleBookConsultation}
                  className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold bg-white hover:bg-gray-100 transition-all duration-300"
                  style={{ color: "var(--color-primary-600)" }}
                  aria-label="Book Free Kitchen Design Consultation"
                >
                  Book Free Consultation
                  <ArrowRight size={18} />
                </button>
                <button 
                  onClick={handleViewAllCollections}
                  className="inline-flex items-center gap-2 border-2 border-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:bg-white/10 transition-all duration-300"
                  style={{ color: "var(--color-white)" }}
                  aria-label="View All Kitchen Cabinet Collections"
                >
                  View All Collections
                </button>
              </div>
            </div>
          </div>

          {/* SEO Footer Keywords */}
          <div className="mt-12 text-center">
            <p className="inter-secondary text-xs opacity-60" style={{ color: "var(--color-gray-500)" }}>
              <strong></strong> Modern Acrylic Kitchen | Matte Finish Cabinets | Glass Front Cabinets | European Style Kitchen  | Modular Kitchen System | Urban Contemporary Kitchen | Signature Collection | Laminance Cabinetry New Jersey
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default CollectionsPage;